"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppError = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
class AppError extends Error {
    constructor(error) {
        super();
        this.code = -1;
        this.details = {};
        if (!(0, isNil_1.default)(error)) {
            this.name = error.name;
            this.message = error.message;
            this.stack = error.stack;
        }
    }
}
exports.AppError = AppError;
